module.exports = __webpack_public_path__ + "img/arrow_right_2.7c7957b3.svg";